import { FlipFlop } from '../../index.js';
import CreditCapabilities from '../../../views/credit/CreditCapabilities/index.js';

export const requirements = {
  flipFlopRequirements: [],
};

export const verifier = () =>
  CreditCapabilities.canEnterCreditPage() || FlipFlop.get('credit-portal-beta', false);
